import React, { useEffect, useState } from 'react';
import '../../shared/styles/styles.css';
import '../../shared/styles/Sidebar.css';
import Sidebar from '../../shared/components/Sidebar';
import GitHubProjectsSection from './GitHubProjectsSection';

const GitHubProjects = () => {
    const [repositories, setRepositories] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('https://api.github.com/users/ZakariaBalali/repos')
            .then((res) => {
                if (!res.ok) throw new Error(`GitHub API error: ${res.status}`);
                return res.json();
            })
            .then(setRepositories)
            .catch((err) => {
                console.error('Failed to fetch repositories:', err);
                setError(err.message);
            });
    }, []);

    return (
        <div className="container">
            <button className="menu-btn" onClick={() => setIsOpen((o) => !o)}>
                &#9776;
            </button>
            <Sidebar isOpen={isOpen} onClose={() => setIsOpen(false)} />
            {error ? (
                <p style={{ color: 'var(--text-muted)', padding: '2rem' }}>
                    Could not load repositories: {error}
                </p>
            ) : (
                <GitHubProjectsSection projects={repositories} />
            )}
        </div>
    );
};

export default GitHubProjects;
